import { call, put, takeEvery } from "redux-saga/effects";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
import { saveXeroxCodeFail, saveXeroxCodeSuccess } from "./action";
import { SAVE_XEROX_CODE } from "./actionType";
import { onSavingXeroxCode } from "helpers/fakebackend_helper";

function* onSaveXeroxCode({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSavingXeroxCode, data);
    yield call(responseHandler, "Integration", response, saveXeroxCodeSuccess, saveXeroxCodeFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(saveXeroxCodeFail(error));
    showToast("error", "Invoice", error);
  }
}

function* IntegrationSaga() {
  yield takeEvery(SAVE_XEROX_CODE, onSaveXeroxCode);
}

export default IntegrationSaga;
